import { useId, useRef, type CSSProperties, type ReactNode } from "react";
import { Button } from "./Button.js";

/**
 * Campo de upload (Design.md §6.2 / §9): input file estilizado que mostra o
 * nome do arquivo selecionado. Usado em "Subir planilha preenchida".
 */
export interface FileUploadProps {
  label: string;
  onFile: (file: File) => void;
  accept?: string;
  fileName?: string | null;
  style?: CSSProperties;
}

export function FileUpload({
  label,
  onFile,
  accept,
  fileName,
  style
}: FileUploadProps): ReactNode {
  const inputId = useId();
  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <div
      style={{ display: "flex", alignItems: "center", gap: "0.6rem", ...(style ?? {}) }}
    >
      <input
        ref={inputRef}
        id={inputId}
        type="file"
        className="visually-hidden"
        accept={accept}
        onChange={(event) => {
          const file = event.target.files?.[0];
          if (file !== undefined) {
            onFile(file);
            // Reseta o value para permitir re-subir o MESMO nome de arquivo
            // (loop corrigir → subir → reenviar).
            event.target.value = "";
          }
        }}
      />
      <Button variant="secondary" onClick={() => inputRef.current?.click()}>
        {label}
      </Button>
      <span style={{ fontSize: 12, color: "var(--text-muted)" }}>
        {fileName !== undefined && fileName !== null && fileName.length > 0
          ? fileName
          : "Nenhum arquivo selecionado"}
      </span>
    </div>
  );
}
